module.exports = __webpack_public_path__ + "static/media/littleleft-girl.29ff68f7.png";